import { InjectionToken } from '@angular/core';

export type BooxMatomoToken = {
    id : string,
    url : string,
    [key: string]: any,
}

export const BOOX_MATOMO = new InjectionToken<BooxMatomoToken | null>('(lib-boox) BOOX_MATOMO', {
    providedIn : 'root', factory: () => null
});
